/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Silently refresh cart after browser Back/Forward restores the page
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    setTimeout(function () {
      const cartItems = document.querySelector('cart-items');

      if (!cartItems) return;

      const cartUrl =
        (window.theme?.routes?.cart_url || '/cart') +
        '?section_id=api-cart-items';

      fetch(cartUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'text/html'
        },
        cache: 'no-store'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart refresh failed');
          return response.text();
        })
        .then(function (html) {
          const wrapper = document.createElement('div');
          wrapper.innerHTML = html;

          const apiContent = wrapper.querySelector('[data-api-content]');
          if (!apiContent) return;

          const apiLineItems = apiContent.querySelector('[data-api-line-items]');
          const apiUpsellItems = apiContent.querySelector('[data-api-upsell-items]');
          const apiBundleItems = apiContent.querySelector('[data-api-bundle-items]');
          const apiCartPrice = apiContent.querySelector('[data-api-cart-price]');
          const apiCartTotal = apiContent.querySelector('[data-cart-total]');

          const itemsHolder = document.querySelector('[data-items-holder]');
          const upsellHolder = document.querySelector('[data-upsell-products]');
          const bundleHolder = document.querySelector('[data-bundle-products]');
          const priceHolder = document.querySelector('[data-cart-price-holder]');
          const cartTotal = document.querySelector('[data-cart-total]');

          // Update cart items
          if (itemsHolder) {
            if (apiLineItems) {
              itemsHolder.innerHTML = apiLineItems.innerHTML;
            } else {
              itemsHolder.innerHTML = apiContent.innerHTML;
            }
          }

          // Update upsells
          if (upsellHolder) {
            upsellHolder.innerHTML = apiUpsellItems
              ? apiUpsellItems.innerHTML
              : '';
          }

          // Update bundle products
          if (bundleHolder) {
            bundleHolder.innerHTML = apiBundleItems
              ? apiBundleItems.innerHTML
              : '';
          }

          // Update cart price
          if (priceHolder && apiCartPrice) {
            priceHolder.innerHTML = apiCartPrice.innerHTML;
          }

          // Calculate current cart quantity from the freshly fetched HTML
          const quantityInputs = apiContent.querySelectorAll(
            'input[name="updates[]"]'
          );

          let cartCount = 0;

          quantityInputs.forEach(function (input) {
            cartCount += parseInt(input.value, 10) || 0;
          });

          // Update ALL Broadcast cart counters
          document.querySelectorAll('cart-count').forEach(function (counter) {
            counter.setAttribute('data-cart-count', cartCount);

            const limit = counter.getAttribute('data-limit');
            const displayCount =
              limit && cartCount >= parseInt(limit, 10)
                ? '9+'
                : cartCount;

            counter.innerText = displayCount;
          });

          // Update cart total
          if (cartTotal && apiCartTotal) {
            cartTotal.innerHTML = apiCartTotal.innerHTML;

            const totalValue = apiCartTotal.getAttribute('data-cart-total');

            if (totalValue !== null) {
              cartTotal.setAttribute('data-cart-total', totalValue);
            }
          }

          // Refresh Broadcast cart item event bindings
          if (typeof cartItems.cartRemoveEvents === 'function') {
            cartItems.cartRemoveEvents();
          }

          if (typeof cartItems.cartUpdateEvents === 'function') {
            cartItems.cartUpdateEvents();
          }

          // Important:
          // DO NOT dispatch:
          // theme:cart:refresh
          // theme:product:added
          // theme:cart:change

          // Therefore Broadcast will NOT trigger its cart drawer opening.
        })
        .catch(function (error) {
          console.log('Silent cart refresh failed:', error);
        });
    }, 100);
  });

  var product__slide = document.querySelectorAll('.product__slide');

  for (let index = 0; index < product__slide.length; index++) {
    var deferredMediaPoster = product__slide[index].querySelector('.deferred-media__poster');
  
    if (deferredMediaPoster) {
      deferredMediaPoster.click();
    }
  }
  
  // product page mobile slider arrows start
  const prevBtn = document.querySelector('.prslide_nav.prslide_left');
  const nextBtn = document.querySelector('.prslide_nav.prslide_right');
  
  if (prevBtn) {
    prevBtn.addEventListener('click', prevClick);
    nextBtn.addEventListener('click', nextClick);
  }
  
  function prevClick() {
    var crSlide = document.querySelector('.product__slide.media--active');
    if (crSlide.previousElementSibling) {
      var nxtSlide = document.querySelector('.product__slide');
  
      var prevElementMediaId = crSlide.previousElementSibling.getAttribute('data-media-id');
  
      console.log(prevElementMediaId);
      const $this = document.querySelector('[data-product-thumbs]');
      $this.dispatchEvent(
        new CustomEvent('theme:media:select', {
          bubbles: true,
          detail: {
            id: prevElementMediaId,
          },
        })
      )
    }
  }
  
  function nextClick() {
    var crSlide = document.querySelector('.product__slide.media--active');
    if (crSlide.nextElementSibling) {
      var nxtSlide = document.querySelector('.product__slide');
  
      var nextElementMediaId = crSlide.nextElementSibling.getAttribute('data-media-id');
  
      console.log(nextElementMediaId);
      const $this = document.querySelector('[data-product-thumbs]');
      $this.dispatchEvent(
        new CustomEvent('theme:media:select', {
          bubbles: true,
          detail: {
            id: nextElementMediaId,
          },
        })
      )
    }
  }
  // product page mobile slider arrows end
  
  var bodyElement = document.body;
  if (bodyElement.classList.contains('template-product')) {
    var videoElem = document.querySelector('.media-video');
    var mediaElement = videoElem.closest('.product__media');
    if (videoElem) {
      if (videoElem.paused) {
        mediaElement.removeAttribute('loaded');
      }
    }
  }

  //Quick add button
  document.addEventListener('click', e => {
    const swatch = e.target.closest('.ezr_add_to_cart_swatch');
    if (!swatch) return;
    
    e.preventDefault();

    const form = swatch.closest('.ezr-quick-add-form');
    if (!form) return;

    const swatches = form.querySelectorAll('.ezr_add_to_cart_swatch');
    const idInput = form.querySelector('input[name="id"]');

    swatches.forEach(s => s.classList.remove('active'));
    swatch.classList.add('active');

    const variantId = swatch.dataset.variantId;
    idInput.value = variantId;
  });

  document.addEventListener('submit', e => {
    const form = e.target.closest('.ezr-quick-add-form');
    if (!form) return;

    e.preventDefault();

    const idInput = form.querySelector('input[name="id"]');
    const addButton = form.querySelector('.ezr_add_button');

    if (!idInput?.value) return;

    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        bubbles: true,
        detail: {
          button: addButton
        }
      })
    );
  });


  /* =========================================================
   EZR PRODUCT GRID OPTIONS
   ========================================================= */
  document.addEventListener('click', async (event) => {
    /*
    * COLOUR CLICK
    */
    const colourButton = event.target.closest('[data-ezr-colour]');

    if (colourButton) {
      event.preventDefault();
      event.stopPropagation();

      await ezrChangeColour(colourButton);
    }
  });
  async function ezrGetProduct(handle) {
    const response = await fetch(
      `${window.Shopify.routes.root}products/${handle}.js`
    );

    if (!response.ok) {
      throw new Error('Unable to load product');
    }

    return response.json();
  }

  function ezrGetSizeOption(product) {
    if (!product.options) return null;

    return product.options.find((option) => {
      return option.name.toLowerCase() === 'size';
    });
  }

  function ezrRenderSizes(card, product) {
    const sizeOption = ezrGetSizeOption(product);

    const valuesContainer = card.querySelector(
      '.ezr-product-grid-option--size .ezr-product-grid-option__values'
    );

    if (!valuesContainer) return;

    valuesContainer.innerHTML = '';

    if (!sizeOption) {
      const sizeRow = card.querySelector(
        '.ezr-product-grid-option--size'
      );

      if (sizeRow) {
        sizeRow.remove();
      }

      return;
    }

    const sizeOptionIndex = product.options.findIndex((option) => {
      return option.name.toLowerCase() === 'size';
    });

    sizeOption.values.forEach((size) => {
      const variant = product.variants.find((item) => {
        return item.options[sizeOptionIndex] === size;
      });

      if (!variant) return;

      /*
      * Create the complete product-form HTML first.
      * This ensures Broadcast's ProductForm constructor
      * finds the <form> immediately.
      */
      const wrapper = document.createElement('div');

      wrapper.innerHTML = `
        <product-form
          class="ezr-product-grid-size-form"
          data-hide-errors="true"
        >
          <form
            method="post"
            action="${window.Shopify.routes.root}cart/add"
            accept-charset="UTF-8"
          >
            <input
              type="hidden"
              name="id"
              value="${variant.id}"
            >

            <button
              type="submit"
              class="ezr-product-grid-size${variant.available ? '' : ' ezr-product-grid-size--unavailable'}"
              data-ezr-size
              data-ezr-variant-id="${variant.id}"
              data-ezr-variant-available="${variant.available}"
              data-ezr-tooltip="${size}"
              aria-label="${size}"
              ${variant.available ? '' : 'disabled'}
            >
              ${size}

              ${
                variant.available
                  ? ''
                  : '<span class="ezr-product-grid-size__line"></span>'
              }
            </button>
          </form>
        </product-form>
      `;

      const productForm = wrapper.firstElementChild;

      valuesContainer.appendChild(productForm);
    });
  }

  async function ezrChangeColour(colourButton) {
    const card = colourButton.closest('[data-grid-item]');

    if (!card) return;

    const handle = colourButton.dataset.ezrProductHandle;

    if (!handle) return;

    if (card.dataset.ezrLoading === 'true') return;

    card.dataset.ezrLoading = 'true';
    card.classList.add('ezr-product-grid-item--loading');

    try {
      const product = await ezrGetProduct(handle);

      /*
      * Selected colour
      */
      card
        .querySelectorAll('[data-ezr-colour]')
        .forEach((button) => {
          button.classList.remove(
            'ezr-product-grid-colour--current'
          );
        });

      colourButton.classList.add(
        'ezr-product-grid-colour--current'
      );


      /*
      * Product state
      */
      card.dataset.ezrProductHandle = product.handle;
      card.dataset.ezrProductId = product.id;


      /*
      * First available variant
      */
      const firstAvailableVariant = product.variants.find(
        (variant) => variant.available
      );

      if (firstAvailableVariant) {
        card.dataset.ezrCurrentVariant =
          firstAvailableVariant.id;
      }


      /*
      * Images
      */
      ezrUpdateProductImages(card, product);


      /*
      * Sizes
      */
      ezrRenderSizes(card, product);

    } catch (error) {
      console.error(
        '[EZR] Unable to change product colour',
        error
      );

    } finally {
      card.dataset.ezrLoading = 'false';
      card.classList.remove(
        'ezr-product-grid-item--loading'
      );
    }
  }

  async function ezrAddToCart(sizeButton) {
    const card = sizeButton.closest('[data-grid-item]');

    if (!card) return;

    const variantId = Number(
      sizeButton.dataset.ezrVariantId
    );

    if (!variantId) return;

    if (
      sizeButton.dataset.ezrVariantAvailable !== 'true'
    ) {
      return;
    }

    if (sizeButton.classList.contains(
      'ezr-product-grid-size--loading'
    )) {
      return;
    }

    sizeButton.classList.add(
      'ezr-product-grid-size--loading'
    );

    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1
              }
            ]
          })
        }
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(
          error.description || 'Unable to add product'
        );
      }

      /*
      * Refresh Broadcast cart
      */
      if (typeof window.refreshCart === 'function') {
        await window.refreshCart();
      }

      /*
      * Open cart drawer
      */
      const cartDrawer =
        document.querySelector('cart-drawer');

      if (cartDrawer?.open) {
        cartDrawer.open();
      }

    } catch (error) {
      console.error(
        '[EZR] Add to cart failed',
        error
      );

    } finally {
      sizeButton.classList.remove(
        'ezr-product-grid-size--loading'
      );
    }
  }

  function ezrUpdateProductImages(card, product) {
    if (!product.images?.length) return;

    const images = product.images;

    /*
    * -----------------------------
    * Main product image
    * -----------------------------
    */
    const defaultImage = card.querySelector(
      '[data-product-image-default] img'
    );

    if (defaultImage) {
      defaultImage.src = images[0];
      defaultImage.removeAttribute('srcset');

      const picture = defaultImage.closest('picture');

      if (picture) {
        picture.querySelectorAll('source').forEach((source) => {
          source.removeAttribute('srcset');
        });
      }
    }


    /*
    * -----------------------------
    * Hover images
    * -----------------------------
    */
    const hoverSlider = card.querySelector(
      '[data-hover-slider]'
    );

    if (!hoverSlider) return;

    const hoverSlides = hoverSlider.querySelectorAll(
      '.product-item__bg__slide'
    );

    /*
    * We use the existing Broadcast slide structure
    * and update each slide's image.
    */
    hoverSlides.forEach((slide, index) => {
      const image = images[index];

      if (!image) {
        slide.style.display = 'none';
        return;
      }

      slide.style.display = '';

      const img = slide.querySelector('img');

      if (!img) return;

      /*
      * Update image source
      */
      img.src = image;

      /*
      * Remove old responsive sources
      */
      img.removeAttribute('srcset');

      /*
      * Update <picture><source> if Broadcast
      * rendered one.
      */
      const picture = img.closest('picture');

      if (picture) {
        picture.querySelectorAll('source').forEach((source) => {
          source.removeAttribute('srcset');
        });
      }

      /*
      * Remove lazy-loading attributes which
      * may still point to the old product image.
      */
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');

      slide.classList.remove('loading');
    });


    /*
    * If the selected product has more images than
    * the current card, create additional slides.
    */
    if (images.length > hoverSlides.length) {
      const existingSlide = hoverSlides[0];

      if (existingSlide) {
        for (
          let index = hoverSlides.length;
          index < images.length;
          index++
        ) {
          const slide = existingSlide.cloneNode(true);

          slide.style.display = '';

          const img = slide.querySelector('img');

          if (img) {
            img.src = images[index];
            img.removeAttribute('srcset');
            img.removeAttribute('data-src');
            img.removeAttribute('data-srcset');

            const picture = img.closest('picture');

            if (picture) {
              picture.querySelectorAll('source').forEach((source) => {
                source.removeAttribute('srcset');
              });
            }
          }

          /*
          * Every slide after the first should have
          * Broadcast's hover-slide attribute.
          */
          slide.setAttribute('data-hover-slide', '');
          slide.setAttribute('data-hover-slide-touch', '');

          hoverSlider.appendChild(slide);
        }
      }
    }
  }
  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

(function () {
    var timer;

    var observer = new MutationObserver(function (mutations) {
        var productChanged = mutations.some(function (mutation) {
            return Array.from(mutation.addedNodes).some(function (node) {
                return node.nodeType === 1 &&
                    (
                        node.matches('[data-grid-item]') ||
                        node.querySelector('[data-grid-item]')
                    );
            }) || Array.from(mutation.removedNodes).some(function (node) {
                return node.nodeType === 1 &&
                    (
                        node.matches('[data-grid-item]') ||
                        node.querySelector('[data-grid-item]')
                    );
            });
        });

        if (!productChanged) return;

        clearTimeout(timer);

        timer = setTimeout(function () {
            if (
                typeof ReloadSmartWishlist !== "undefined" &&
                $.isFunction(ReloadSmartWishlist)
            ) {
                ReloadSmartWishlist();
            }
        }, 200);
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
})();